import type { IconSvgObject } from './types';

const TeamviewerIcon: IconSvgObject = [
  ["path", { d: "M19.5 2.5C20.6046 2.5 21.5 3.39543 21.5 4.5V19.5C21.5 20.6046 20.6046 21.5 19.5 21.5H4.5C3.39543 21.5 2.5 20.6046 2.5 19.5V4.5C2.5 3.39543 3.39543 2.5 4.5 2.5H19.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.5 8.50024V10.6565H14.5V8.50024L18.5 12.0002L14.5 15.5002V13.3401H9.5V15.5002L5.5 12.0002L9.5 8.50024Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TeamviewerIcon;
